// extracted by mini-css-extract-plugin
module.exports = {"openModal":"html_openModal__1J-2d","openHeader":"html_openHeader__2ETYr"};